import React from 'react';
import ReactDOM from 'react-dom';
import PortfolioApp from './PortfolioApp';
import './estilos/styles.scss'
ReactDOM.render(
  <React.StrictMode>
    <PortfolioApp />
  </React.StrictMode>,
  document.getElementById('root')
);
